export const LEAD_SOURCES = {
  ALL: 'all',
  LINKEDIN: 'linkedin',
  FACEBOOK: 'facebook',
  OFFLINE: 'offline',
}

export const LEAD_SOURCE_OPTIONS = [
  { value: LEAD_SOURCES.ALL, label: 'All sources' },
  { value: LEAD_SOURCES.LINKEDIN, label: 'LinkedIn' },
  { value: LEAD_SOURCES.FACEBOOK, label: 'Facebook' },
  { value: LEAD_SOURCES.OFFLINE, label: 'Offline' },
]

export const LEAD_WARMTH = {
  HOT: 'hot',
  WARM: 'warm',
  COLD: 'cold',
}

export const PAGE_SIZE = 5
